
import { useEffect } from 'react';
import { app } from "@microsoft/teams-js";
import Config from '../../../config';
import { UserService } from '../../../services/UserService';
import { LocalStorage, UtilityService } from '../../../services/UtilityService';

const OutlookPopup = () => {

    const OrgRef = UserService.getCurrentUserOrgRef()

    useEffect(() => {

        app.initialize().then(() => {
            const rootUrl = `${Config.API_URL}/api/Outlook/Connect?OrgRef=${OrgRef}&userId=${LocalStorage.get('current-user')?.id}&phoneNumber=${UtilityService.unmaskPhoneNumber(LocalStorage.get("current-user")?.phoneNumber)}`;
            window.location.assign(rootUrl)
        })

    }, []);
    return (
        <div className="ms-Fabric">
            <div id="content">
                <p>Redirecting to Azure AD to request permission consent</p>
            </div>
        </div>
    );
};

export default OutlookPopup;
